import React from 'react';

interface IconProps {
  color?: string;
  size?: number;
}

export const BankIcon: React.FC<IconProps> = ({ color = 'currentColor', size = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M3 10h18" />
    <path d="M12 3l9 7H3l9-7z" />
    <path d="M5 10v11" />
    <path d="M9.5 10v11" />
    <path d="M14.5 10v11" />
    <path d="M19 10v11" />
  </svg>
);

export const CoinsIcon: React.FC<IconProps> = ({ color = 'currentColor', size = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="6" rx="8" ry="3" />
    <path d="M4 6v4c0 1.66 3.58 3 8 3s8-1.34 8-3V6" />
    <path d="M4 10v4c0 1.66 3.58 3 8 3s8-1.34 8-3v-4" />
    <path d="M4 14v4c0 1.66 3.58 3 8 3s8-1.34 8-3v-4" />
  </svg>
);

export const WomenIcon: React.FC<IconProps> = ({ color = 'currentColor', size = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const DefaultProductIcon: React.FC<IconProps> = ({ color = 'currentColor', size = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
  </svg>
);
